// Components
// Hooks
import { useKeyActions } from '@/utils/hooks/homeKeyActions/useKeyActions';

import { ActionItem } from '@/components/pages/home/keyActions/actionItem';

export const HomeKeyActions = () => {
    const actionsCatalog = useKeyActions();
    return (
        <div
            data-testid="dashboard-actions"
            className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
            {actionsCatalog.map((action) => (
                <ActionItem key={action.type} action={action} />
            ))}
        </div>
    );
};
